(function () {
  function initSliders(root) {
    root.querySelectorAll('[data-st-slider]').forEach(function (el) {
      if (el.dataset.stReady) return;
      el.dataset.stReady = '1';
      var slides = el.querySelectorAll('.st-slide');
      if (slides.length < 2) return;
      var i = 0;
      var speed = parseInt(el.dataset.speed || '4', 10) * 1000;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-st-tabs]').forEach(function (wrap) {
      if (wrap.dataset.stReady) return;
      wrap.dataset.stReady = '1';
      var tabs = wrap.querySelectorAll('.st-tab');
      var panels = wrap.querySelectorAll('.st-panel');
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          tab.setAttribute('aria-selected', 'true');
          if (panels[idx]) panels[idx].classList.add('is-active');
        });
      });
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.st-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initSticky() {
    var bar = document.querySelector('[data-st-sticky]');
    if (!bar || bar.dataset.stReady) return;
    bar.dataset.stReady = '1';
    var target = document.querySelector('.st-buy__form, product-form, .product-form');
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    }).observe(target);
    var btn = bar.querySelector('[data-st-sticky-btn]');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      var real = target.querySelector('[type="submit"]');
      if (real) { real.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function(){ real.click(); }, 350); }
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-st-buy]').forEach(function (box) {
      if (box.dataset.stReady) return;
      box.dataset.stReady = '1';
      var main = box.querySelector('[data-st-main] img');
      box.querySelectorAll('.st-thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          if (main) { main.removeAttribute('srcset'); main.src = t.dataset.src; }
          box.querySelectorAll('.st-thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  function parseEnd(v) { if (!v) return null; var d = new Date(v.trim().replace(' ', 'T')); return isNaN(d) ? null : d; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdowns() {
    if (window.__stClock) return;
    function tick() {
      var now = Date.now();
      document.querySelectorAll('[data-st-hide-on-end]').forEach(function (el) {
        var end = parseEnd(el.dataset.end); if (end && end - now <= 0) el.style.display = 'none';
      });
      document.querySelectorAll('[data-st-clock]').forEach(function (el) {
        var end = parseEnd(el.dataset.end); if (!end) return;
        var t = Math.max(0, Math.floor((end - now) / 1000));
        el.querySelector('[data-d]').textContent = pad(Math.floor(t / 86400));
        el.querySelector('[data-h]').textContent = pad(Math.floor(t % 86400 / 3600));
        el.querySelector('[data-m]').textContent = pad(Math.floor(t % 3600 / 60));
        el.querySelector('[data-s]').textContent = pad(t % 60);
      });
      document.querySelectorAll('[data-st-countdown]').forEach(function (el) {
        var end = parseEnd(el.dataset.end); if (!end) return;
        var t = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = Math.floor(t / 86400) + 'd ' + pad(Math.floor(t % 86400 / 3600)) + ':' + pad(Math.floor(t % 3600 / 60)) + ':' + pad(t % 60);
      });
    }
    tick(); window.__stClock = setInterval(tick, 1000);
  }
  function fmt(cents, format) {
    var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var withComma = n.replace('.', ',');
    format = format || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('comma') > -1) return withComma;
      if (k.indexOf('no_decimals') > -1) return Math.round(cents / 100).toString();
      return n;
    });
  }
  function initBuyForm(root) {
    root.querySelectorAll('[data-st-buy]').forEach(function (box) {
      if (box.dataset.stFormReady) return;
      box.dataset.stFormReady = '1';
      var btnPrice = box.querySelector('[data-st-btn-price]');
      var sub = box.querySelector('[data-st-sub]');
      var planInput = box.querySelector('[data-st-plan-input]');
      var subPrice = box.querySelector('[data-st-sub-price]');
      var subWas = box.querySelector('[data-st-sub-was]');
      var mp = box.querySelector('[data-st-main-price]');
      var mc = box.querySelector('[data-st-main-compare]');
      var cents = btnPrice ? parseInt(btnPrice.dataset.cents || '0', 10) : 0;
      var compareTxt = mc ? mc.textContent : '';
      function render() {
        var pct = sub ? parseInt(sub.dataset.pct || '0', 10) : 0;
        var format = sub ? sub.dataset.format : null;
        var subCents = Math.round(cents * (100 - pct) / 100);
        var on = sub && sub.checked && pct > 0;
        if (subPrice && cents) subPrice.textContent = fmt(subCents, format);
        if (subWas && cents) subWas.textContent = fmt(cents, format);
        if (btnPrice && cents) btnPrice.textContent = fmt(on ? subCents : cents, format);
      }
      box.querySelectorAll('input[name="id"][type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.dataset.cents) cents = parseInt(r.dataset.cents, 10);
          if (mp && r.dataset.price) mp.textContent = r.dataset.price;
          if (mc) mc.textContent = r.dataset.compare || '';
          if (btnPrice && r.dataset.price && !(sub && sub.checked)) btnPrice.textContent = r.dataset.price;
          render();
        });
      });
      if (sub && planInput) sub.addEventListener('change', function () { planInput.disabled = !sub.checked; render(); });
      render();
    });
  }

  function initAll(root) {
    root = root || document;
    initSliders(root); initTabs(root); initGallery(root); initBuyForm(root); initCountdowns(); initReveal(root); initSticky();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
